<template>
  <v-layout wrap>
    <v-flex xs12 v-for="(service, index) in services" :key="service.id || index" py-2>
      <advanced-service-picker :title="service.name" :services="service.service_items"/>
    </v-flex>
  </v-layout>

</template>

<script>
  import AdvancedServicePicker from '@/components/providers/services/AdvancedServicePicker'
  export default{
    components: { AdvancedServicePicker },
    async mounted(){
      await this.$store.dispatch('services/loadServices')
    },
    computed: {

      services() {
        return this.$store.getters['services/availableServices']
      },

    }
  }
</script>
